import { render, staticRenderFns } from "./thirdfirst.vue?vue&type=template&id=8b2c8028&"
import script from "./thirdfirst.vue?vue&type=script&lang=js&"
export * from "./thirdfirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b2c8028')) {
      api.createRecord('8b2c8028', component.options)
    } else {
      api.reload('8b2c8028', component.options)
    }
    module.hot.accept("./thirdfirst.vue?vue&type=template&id=8b2c8028&", function () {
      api.rerender('8b2c8028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/third/thirdfirst.vue"
export default component.exports